export default "__VITE_ASSET__Dv3OwxY2__"